// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__3lbZC","slick-next":"CustomSlider_slick-next__3xmB-"};